/**
 * Query Types
 */
export const OWNED_BY_ME = 'OWNED_BY_ME'
// export const SHARED_BY_ME = 'SHARED_BY_ME'
// export const SHARED_WITH_ME = 'SHARED_WITH_ME'

/**
 * Sort By Types
 */
export const FILE_NAME = 'fileName'
export const LAST_ACCESSED = 'lastAccessed'
export const UPLOADED_DATE = 'uploadedDate'

/**
 * Resource Types
 */
// export const IMAGE = 'IMAGE'
// export const PDF = 'PDF'
export const NOTEBOOK = 'NOTEBOOK'
// export const GALLERY = 'GALLERY'

/**
 * Sort Order Types
 */
export const DESCENDING = 'DESCENDING'
